<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <BaseText>
          {{ $t('admin.invoices.datev.description') }}
        </BaseText>
        <div :class="$style.formRow">
          <BaseInput
            v-model="formData.settings.datev.billsReceivableAccount"
            type="number"
            :label="
              $t('admin.invoices.datev.bills_receivable_account')
            "
            v-test="'billsReceivableAccount'"
          />
          <BaseInput
            v-model="formData.settings.datev.deferredRevenueAccount"
            type="number"
            :label="
              $t('admin.invoices.datev.deferred_revenue_account')
            "
            v-test="'deferredRevenueAccount'"
          />
        </div>
        <div :class="$style.formRow">
          <BaseInput
            v-model="formData.settings.datev.cashAccount"
            type="number"
            :label="$t('admin.invoices.datev.cash_account')"
            v-test="'cashAccount'"
          />
          <BaseInput
            v-model="formData.settings.datev.bankAccount"
            type="number"
            :label="$t('admin.invoices.datev.bank_account')"
            v-test="'bankAccount'"
          />
        </div>
        <div :class="$style.formRow">
          <BaseInput
            v-model="formData.settings.datev.revenueAccount"
            type="number"
            :label="$t('admin.invoices.datev.revenue_account')"
            v-test="'revenueAccount'"
          />
        </div>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { inject } from 'vue';

const formData = inject<any>('formData');
</script>

<style
  lang="scss"
  module
>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > * {
    width: calc(50% - #{$spacing * 0.5});
  }

  .base.smallScreen & {
    & > * {
      width: 100%;
    }
  }
}
</style>
